<style lang="less" scoped>
.content {
  padding: 20px;
  font-size: 20px;
  .item-title {
    color: black;
    font-weight: bold;
  }
  .quInfo {
    margin: 0 2em 1em 2em;
  }
  .articleTitle {
    text-align: center;
    font-size: 24px;
  }
  .article {
    font-family: 'gwc';
  }
  .article u {
    color: @primary-color!important;
  }
  .tigan {
    margin-bottom: 10px;
  }
  .input-box {
    margin: 1em 2em;
  }
}
.choose-item {
  display: flex;
  align-items: center;
}
// .choose-item:hover{
//   color: rgb(184, 7, 146);
// }
.choose-item span {
  margin-right: 1.5em;
}
.choose-item span:first-child {
  margin-right: 1em;
  font-weight: bold;
}
.analysis-content {
  font-size: 16px;
  text-align: justify;
  background-color: #e6f8f3;
  border-radius: 4px;
  padding: 1em;
  margin: 1em 2em;
  white-space: pre-wrap;
}
.ant-radio-button-wrapper,
.ant-checkbox-wrapper {
  position: static;
  width: 100%;
  font-size: 16px;
  background-color: #f5f9fe;
  border-radius: @border-radius-base!important;
  display: flex;
  margin: 5px;
  border: none;
  padding: 10px;
  height: auto;
}
.ant-radio-button-wrapper:hover {
  position: static;
}
.ant-radio-button-wrapper:first-child {
  border-left: none;
}
.ant-radio-button-wrapper:last-child {
  border-left: none;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: #6195d1;
  box-shadow: none;
}
.ant-radio-group-default,
.ant-checkbox-group {
  width: 100%;
  padding-left: 2em;
  padding-right: 2.5em;
  margin-top: -10px;
  margin-bottom: 10px;
}
.ant-checkbox-wrapper {
  padding: 5px 10px;
}
.ant-checkbox-wrapper:first-child {
  margin-left: 8px;
}
/deep/.ant-checkbox-inner {
  width: 25px;
  height: 25px;
  top: 50%;
  transform: translate(0%, -50%);
}
/deep/.ant-checkbox-inner::after {
  width: 10px;
  height: 14px;
}
/deep/.ant-checkbox-checked::after {
  border: none;
}
/deep/.ant-modal-header,
/deep/.ant-modal-content {
  background-color: #f1f0f0;
  border-radius: @border-radius-base;
}
/deep/.ant-modal-close {
  color: @primary-color;
}
.ant-radio-button-wrapper.ant-radio-button-wrapper-disabled.wrong {
  color: #666;
}
.ant-radio-button-wrapper-checked.ant-radio-button-wrapper-disabled.wrong,
.ant-checkbox-wrapper-checked.ant-checkbox-wrapper-disabled.wrong {
  background-color: rgba(250, 50, 50, 0.6);
  .r {
    display: none;
  }
  .w {
    display: block;
  }
  .choose-item {
    color: white;
  }
}
.c,
.w {
  display: none;
}
.ant-radio-button-wrapper-disabled.correct,
.ant-checkbox-wrapper-disabled.correct {
  background-color: rgba(6, 153, 116, 0.6);
  .c {
    display: block;
  }
  .w {
    display: none;
  }
  .choose-item {
    color: white;
  }
}
.btn {
  width: 280px;
  height: 50px;
  border-radius: 30px;
  font-size: 24px;
  color: @white;
}
.green-btn {
  background-color: #06bc8c;
}
.orange-btn {
  background-color: #ff9a4a;
}
.green-txt {
  color: #06bc8c;
}
.orange-txt {
  color: #ff9a4a;
}
.analysis-btn {
  margin: 5px;
  padding: 5px 10px;
  cursor: pointer;
}
.margin {
  margin-left: 1.5em;
}
</style>
<template>
  <div ref='exer' :class="{margin: level===3}">
    <h3 class="tigan" v-if="question.title" v-html="question.title"></h3>
    <practiceInfo v-if="question.quInfo" class="quInfo" :content="question.quInfo"></practiceInfo>
    <!-- ite.quType===2 判断题 5 单项选择题 -->
    <div style="text-align:right;margin-bottom:15px">
      <span style="margin-right:30px" v-if="question.degree">难度：{{question.degree}}</span>
      <span style="margin-right:30px" v-if="question.trainPoint">思维层级：{{question.trainPoint}}</span>
      <span style="margin-right:30px" v-if="question.writingStyle">文体:{{question.writingStyle}}</span>
    </div>
    <a-radio-group button-style="solid" v-if="question.quType === 5 || question.quType === 2"
                   :disabled="showAnalysis" v-model="myAnswer">
      <a-radio-button v-for="option in question.options" :value="option.id" :key="option.id"
                      :class="option.isRight?'correct':'wrong'">
        <div class="choose-item">
          <span>{{ option.label }}</span>
          <span v-html="option.content"></span>
          <span v-if="showAnalysis">
            <a-icon class="c" type="check" />
            <a-icon class="w" type="close" />
          </span>
        </div>
      </a-radio-button>
    </a-radio-group>
    <!-- ite.quType===3 简答题 -->
    <div class="input-box" v-if="question.quType === 3">
      <a-textarea v-model="myAnswer" placeholder="请输入答案！" :disabled="showAnalysis"
                  :auto-size="{ minRows: 2, maxRows: 6 }" />
    </div>
    <!-- ite.quType===6 多项选择题 -->
    <a-checkbox-group v-model="myAnswer" :disabled="showAnalysis" v-if="question.quType === 6">
      <a-checkbox v-for="option in question.options" :value="option.id" :key="option.id"
                  :class="option.isRight?'correct':'wrong'">
        <div class="choose-item">
          <span>{{ option.label }}</span>
          <span v-html="option.content"></span>
          <span v-if="showAnalysis">
            <a-icon class="c" type="check" />
            <a-icon class="w" type="close" />
          </span>
        </div>
      </a-checkbox>
    </a-checkbox-group>
    <!-- ite.quType===4 写作体 -->
    <div class="input-box" v-if="question.quType === 4">
      <a-textarea v-model="myAnswer" :disabled="showAnalysis" placeholder="请输入答案！"
                  :auto-size="{ minRows: 6, maxRows: 10 }" />
    </div>
    <div v-if="showAnalysis" style="text-align: right;margin-right:1em">
      <span class="analysis-btn green-txt" v-if="exercise.answer"
            @click="setShowAnswerAnalyContents(0)">参考答案</span>
      <span class="analysis-btn orange-txt" v-if="exercise.quAnalyse"
            @click="setShowAnswerAnalyContents(1)">查看解析</span>
    </div>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div class="analysis-content green-txt" v-show="showSysAnswersContents&&showAnalysis">
        <h4>参考答案：</h4>
        <div v-html="question.answer"></div>
      </div>
    </transition>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div class="analysis-content green-txt" v-show="showAnalyContents&&showAnalysis">
        <h4>解析：</h4>
        <div v-html="question.quAnalyse"></div>
      </div>
    </transition>
  </div>
</template>
<script>
import practiceInfo from './PracticeInfo.vue';
export default {
  name: 'practice',
  components: { practiceInfo },
  props: {
    exercise: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showNumber: {
      type: Boolean,
      default: true,
    },
    showAnalysis: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      myAnswer: null,
      blankAnswer: [],
      showAnalyContents: false,
      showSysAnswersContents: false,
    };
  },
  watch: {
    exercise(val) {
      this.setCurUserAnswer();
    },
    myAnswer(val) {
      this.$emit('do', val, this.exercise.id);
    },
  },
  computed: {
    // 将填空题和多选题用户答案转换为数组
    question() {
      const obj = {
        title: this.showNumber
          ? `${this.level === 3 ? '(' : ''}${this.exercise.quNum}${this.level === 3 ? ') ' : '. '}${
              this.exercise.title
            }`
          : this.exercise.title,
      };
      // 选择题 label 拆分
      if (this.exercise.quType === 5 || this.exercise.quType === 2 || this.exercise.quType === 6) {
        const options = this.exercise.options.map((option) => {
          return Object.assign(option, {
            label: option.optionContent.charAt(0),
            content: option.optionContent.substring(1, option.optionContent.length).trim(),
          });
        });
        obj.options = options;
      }
      let qu = Object.assign({}, this.exercise, obj);
      qu = {
        ...qu,
        answer: qu.answer?.replace(/src=['"][^http]([^'"]+)[^>]/g, `src="${this.$resBasePath}/$1"`),
        quAnalyse: qu.quAnalyse?.replace(/src=['"][^http]([^'"]+)[^>]/g, `src="${this.$resBasePath}/$1"`),
      };
      return qu;
    },
  },
  methods: {
    setCurUserAnswer() {
      // 将填空和多选题用户答案转为数组形式
      if (!this.exercise.userAnswer) return;
      this.myAnswer =
        this.exercise.quType === 1 || this.exercise.quType === 6
          ? this.exercise.userAnswer?.split(',')
          : this.exercise.userAnswer;
    },
    initBlank() {
      const blanks = this.$refs.exer.querySelectorAll('blank');
      this.blankAnswer = new Array(blanks?.length || 0);
      blanks.forEach((blank, index) => {
        blank.setAttribute('title', '点击输入');
        this.showAnalysis ? blank.setAttribute('contenteditable', false) : blank.setAttribute('contenteditable', true);
        this.blankAnswer[index] = blank.innerText = Array.isArray(this.myAnswer) ? this.myAnswer[index] || '' : '';
        blank.addEventListener('input', (event) => {
          this.blankChange(event, index);
        });
      });
    },
    blankChange(event, index) {
      this.blankAnswer[index] = event.target.innerText;
      this.myAnswer = this.blankAnswer.map((an) => an);
    },
    setShowAnswerAnalyContents(i) {
      if (i === 0) {
        this.showSysAnswersContents = !this.showSysAnswersContents;
        return;
      }
      this.showAnalyContents = !this.showAnalyContents;
      //window._czc.push(['_trackEvent', '做练习', i === 0 ? '查看答案' : '查看解析'])
    },
  },
  mounted() {
    this.setCurUserAnswer();
    this.initBlank();
  },
};
</script>
